module.exports = __webpack_public_path__ + "static/media/direct-inbox.b27a55cb.svg";